module.exports = __webpack_public_path__ + "static/media/4.8818c0fc.jpg";